import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, EMPTY, throwError as observableThrowError } from 'rxjs';
import { Router } from '@angular/router';
import { tap, catchError } from 'rxjs/operators';

import { ContextService } from '../core/context.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router, private contextService: ContextService) { }

  private handleHttpError(err: HttpErrorResponse): Observable<any> {
    if (err.status === 401 || err.status === 403) {
      this.contextService.clearLoginData();
      this.router.navigate(['/login']);
      return EMPTY;
    }
    return observableThrowError(err.error || `Http error: status=${err.status} text=${err.statusText}`);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.endsWith('/user/login') === true) {
      return next.handle(req);
    }

    const authHeader = 'Bearer ' + sessionStorage.getItem('Jwt');
    const authReq = req.clone({headers: req.headers.set('Authorization', authHeader)});

    return next.handle(authReq).pipe(
      tap(event => {
          if (event instanceof HttpErrorResponse) {
            this.handleHttpError(event);
          }
        }),
        catchError((err, caught) => {
          return this.handleHttpError(err);
        })
    );
  }
}
